/**
 * スタッフページかどうかを判定
 * @param pathname - location.pathname
 * @returns スタッフページの場合true
 */
export const isStaffPage = (pathname: string): boolean => {
  return pathname.startsWith('/staff');
};
